import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState } from "react";
import { Icon } from "@blueprintjs/core";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";
import { ImageContainer } from "../components/ImageContainer";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page19 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Sentiment Algo'ya Nasıl Ulaşırım?");
  }, []);

  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title="YASAL UYARI" />

      <div
        style={{
          width: "100%",
          height: "100%",
          paddingInline: "10px",
          fontFamily: "Open Sans",
        }}
      >
        <div
          style={{
            backgroundColor: "#F7AF3D",
            padding: "5px 10px",
            fontWeight: "600",
            marginBottom: "10px",
            borderRadius: "2px",
            fontSize: "20px",
          }}
        >
          Sorumluluk Beyanı{" "}
        </div>

        <div style={{ color: "black", fontSize: 22, lineHeight: "33px" }}>
          <p>
            Bu raporda yer alan her türlü bilgi, değerlendirme, yorum,
            istatistiki şekil ve bilgiler hazırlandığı tarih itibari ile mevcut
            piyasa koşulları ve güvenirliğine inanılan kaynaklardan Sentiment
            Algo sistemi verileri elde edilerek derlenmiştir ve Zephlex Finansal
            Teknolojiler AŞ tarafından genel bilgilendirme amacı ile
            hazırlanmıştır. Sunulan bilgilerin doğruluğu ve bunların yatırım
            kararlarına uygunluğu tarafımızca garanti edilmemektedir. Bu
            bilgiler belli bir getirinin sağlanmasına yönelik olarak
            verilmemekte olup alım-satım kararını destekleyebilecek yeterli
            bilgiler burada bulunmayabilir. Herhangi bir yatırım aracının
            alım-satım önerisi ya da getiri vaadi olarak yorumlanmamalıdır. Bu
            görüşler mali durumunuz ile risk ve getiri tercihlerinize uygun
            olmayabilir. Sadece burada yer alan bilgilere dayanarak yatırım
            kararı verilmesi beklentilerinize uygun sonuçlar doğurmayabilir. Bu
            nedenle bu sayfalarda yer alan bilgilerdeki hatalardan
            eksikliklerden ya da bu bilgilere dayanılarak yapılan işlemlerden,
            yorum ve bilgilerin kullanılmasından doğacak her türlü maddi/manevi
            zararlardan ve her ne şekilde olursa olsun üçüncü kişilerin
            uğrayabileceği her türlü doğrudan ve/veya dolaylı zararlardan dolayı
            Zephlex Finansal Teknolojiler AŞ ile bağlı kuruluşları, çalışanları,
            yöneticileri ve ortakları sorumlu tutulamaz. Burada yer alan yatırım
            bilgi, yorum ve tavsiyeleri yatırım danışmanlığı kapsamında
            değildir.
          </p>
        </div>
      </div>
    </WeeklyPage>
  );
};
